import React from 'react'
import { Button, Flex, Form, notification, Popconfirm, Typography } from 'antd'
import dayjs from 'dayjs'
import {
  HandleTimeOffAllocationExpiryRequest,
  ProcessAnnualTimeOffRolloverRequest,
} from '@/features/time-off/time-off-request.def.ts'
import { useTriggerExpiryMutation, useTriggerRolloverMutation } from '@/features/time-off/time-off.api.ts'
import { handleApiError } from '@/utils/api.tsx'
import { AntdForm } from '@/common/components/AntdForm'

export const TimeOffTestPanel: React.FC = () => {
  const [triggerRollover, { isLoading: isRollingOver }] = useTriggerRolloverMutation()
  const [triggerExpiry, { isLoading: isExpirying }] = useTriggerExpiryMutation()

  const [rolloverForm] = Form.useForm<ProcessAnnualTimeOffRolloverRequest>()
  const [expiryForm] = Form.useForm<HandleTimeOffAllocationExpiryRequest>()

  const availableYears = Array.from({ length: dayjs().year() - 2019 + 2 }, (_, i) => (dayjs().year() + 1) - i)

  const handleTriggerRollover = async () => {
    try {
      const values = await rolloverForm.validateFields()
      await triggerRollover(values).unwrap()
      notification.success({ message: 'Rollover triggered successfully' })
    } catch (e) {
      handleApiError(e)
    }
  }

  const handleTriggerExpiry = async () => {
    try {
      const values = await expiryForm.validateFields()
      await triggerExpiry(values).unwrap()
      notification.success({ message: 'Expiry triggered successfully' })
    } catch (e) {
      handleApiError(e)
    }
  }

  return (
    <Flex gap="large" wrap="wrap">
      <Flex vertical gap="small" className="p-4 bg-gray-50 rounded-lg">
        <Typography.Text strong>Trigger Rollover</Typography.Text>
        <Form form={rolloverForm} layout="vertical">
          <AntdForm.ManagedCountry fieldProps={{ name: 'countries', rules: [{ required: true, message: 'Required' }] }} />
          <AntdForm.Select
            fieldProps={{ name: 'currentYear', label: 'year', rules: [{ required: true, message: 'Required' }] }}
            options={availableYears.map(y => ({ label: y.toString(), value: y.toString() }))}
          />
          <Form.Item>
            <Popconfirm title="Trigger rollover?" onConfirm={handleTriggerRollover} okText="Yes" cancelText="No">
              <Button type="primary" loading={isRollingOver}>Trigger Rollover</Button>
            </Popconfirm>
          </Form.Item>
        </Form>
      </Flex>

      <Flex vertical gap="small" className="p-4 bg-gray-50 rounded-lg">
        <Typography.Text strong>Trigger Expiry</Typography.Text>
        <Form form={expiryForm} layout="vertical">
          <AntdForm.ManagedCountry fieldProps={{ name: 'countries', rules: [{ required: true, message: 'Required' }] }} />
          <Form.Item>
            <Popconfirm title="Trigger expiry?" onConfirm={handleTriggerExpiry} okText="Yes" cancelText="No">
              <Button type="primary" loading={isExpirying}>Trigger Expiry</Button>
            </Popconfirm>
          </Form.Item>
        </Form>
      </Flex>
    </Flex>
  )
}
